<template>
  <div class="main">
    <div class="container">
      <div class="left-side">
        <h1 class="title-404">Oh, this page seems to be missing.</h1>
        <p class="description-404">
          This page doesn’t exist or was removed. Let’s take you back home.
        </p>
        <main-button text="Back to homepage" @click="goToHomePage()" />
      </div>
      <div class="text-404">404</div>
    </div>
  </div>
</template>

<script>
import ApplicationHeader from './application-header.vue'
import ApplicationFooter from './application-footer.vue'
import { frontendURL } from '../../utils'

export default {
  name: 'error-404',
  components: { ApplicationHeader, ApplicationFooter },
  data() {
    return {
      frontendURL: frontendURL,
    }
  },
  methods: {
    goToHomePage() {
      window.open(this.frontendURL, '_self')
    },
  },
}
</script>

<style scoped>
.main {
  height: 100%;
  width: 100%;
}
.container {
  width: 80%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  padding-top: 5rem;
}
.text-404 {
  align-self: flex-start;
  height: fit-content;
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 900;
  font-size: 96px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-right: 6.25rem;
}
.title-404 {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 800;
  font-size: 36px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 4.5rem;
}
.description-404 {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  color: #979797;
  margin-bottom: 2rem;
}
.left-side {
  max-width: 448px;
  padding-top: 5.5rem;
}
@media screen and (max-width: 1045px) {
  .container {
    flex-direction: column-reverse !important;
    align-items: center !important;
    padding-top: 3rem !important;
    justify-content: flex-end !important;
  }
  .text-404 {
    align-self: unset !important;
  }
  .left-side {
    padding-top: 2rem !important;
  }
}
</style>
